// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.external-stat__stat {
    margin-top: 14px;
}

.external-stat__stat-header {
    display: flex;
    align-items: center;
}
.external-stat__stat-header__image {
    display: flex;
    align-items: center;
}

.external-stat__stat-header__image img {
    width: 53px;
    height: 53px;
    border-radius: 50%;
    margin-right: 8px;
}

.external-stat__stat-header__image .icon-trophy {
    color: var(--white-color);
    background: var(--new-icon-color);
    padding: 12px;
    font-size: 30px;
    border-radius: 50%;
    margin-right: 8px;
}

.external-stat__stat-header__title,
.external-stat__stat-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.external-stat__stat-header__title-name.baloa-subtitle-2{
    color: var(--primary-very-dark-color);
    align-self: flex-start;
}

.external-stat__stat-header__title-name .hubicon-verified {
    font-size: 20px;
    cursor: pointer;
}

.external-stat__stat-header__tags {
    display: flex;
    align-items: center;
    margin-top: 8px;
    gap: 4px;
}

.external-stat__stat-header__tags .baloa-table {
    color: var(--primary-dark-color);
}

.external-stat__stat-header__tags .baloa-table-column {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
    padding: 3px 6px;
    border-radius: 25px;
    background-color: var(--new-background-color);
    border: 1px solid var(--new-gray-color);
}

.external-stat__stat-content__icons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 24px;
    color: var(--primary-dark-color);
    width: 100%;
    margin-top: 16px;
    background: var(--new-background-color);
    padding: 6px 10px;
    border-radius: 4px;
}

.external-stat__stat-content__icons .baloa-normal-medium {
    color: var(--primary-dark-color);
    margin: auto;
    position: relative;
}

.external-stat__stat-content__icons .hubicon-titular,
.external-stat__stat-content__icons .icon-ball,
.external-stat__stat-content__icons .hubicon-assists,
.external-stat__stat-content__icons .hubicon-goalkeeper {
    margin: auto;
    position: relative;
}

.external-stat__stat-content__data {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 24px;
    color: var(--primary-dark-color);
    width: 100%;
    margin-top: 16px;
    padding: 0 10px 24px 10px;
    border-bottom: 1px solid var(--new-gray-background-color);
}

.external-stat__stat-content__data .baloa-normal-medium {
    color: var(--primary-dark-color);
    margin: auto;
}

.external-stat__stat-header__edit-button {
    align-self: flex-end;
    margin-left: auto;
}

.external-stat__stat-header__edit-button .hubicon-edit{
    color: var(--basic-gray-color);
    font-size: 20px;
    cursor: pointer;
}

.external-stat__stat-content__icons__yellow-card {
    width: 18px;
    height: 24px;
    background-color: var(--new-yellow-warning-color);
    position: relative;
    margin: auto;
}
.external-stat__stat-content__icons__red-card {
    width: 18px;
    height: 24px;
    background-color: var(--error-color);
    position: relative;
    margin: auto;
}

.external-stat__stat-content__icons__blue-card {
    width: 18px;
    height: 24px;
    background-color: #0273FF;
    position: relative;
    margin: auto;
}

.external-stat__tooltip{
    visibility: hidden;
    width: 100px;
    background-color: var(--primary-dark-color);
    color: var(--white-color);
    text-align: center;
    border-radius: var(--space-and-half);
    padding: 5px 0;
    box-shadow: 0px 1px 2px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1000;
    bottom: 40px;
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: bold;
    font-size: var(--space-half-quarter);
    line-height: var(--space);
    right: -45px;
}

.external-stat__stat-content__icons .played_games:hover,
.external-stat__stat-content__icons .hubicon-titular:hover,
.external-stat__stat-content__icons .hubicon-goalkeeper:hover,
.external-stat__stat-content__icons .hubicon-assists:hover,
.external-stat__stat-content__icons .icon-ball:hover,
.external-stat__stat-content__icons .external-stat__stat-content__icons__yellow-card:hover,
.external-stat__stat-content__icons .external-stat__stat-content__icons__red-card:hover,
.external-stat__stat-content__icons .external-stat__stat-content__icons__blue-card:hover {
    cursor: pointer;
}

.external-stat__stat-content__icons .played_games:hover .external-stat__tooltip,
.external-stat__stat-content__icons .hubicon-titular:hover .external-stat__tooltip,
.external-stat__stat-content__icons .hubicon-goalkeeper:hover .external-stat__tooltip,
.external-stat__stat-content__icons .hubicon-assists:hover .external-stat__tooltip,
.external-stat__stat-content__icons .icon-ball:hover .external-stat__tooltip,
.external-stat__stat-content__icons .external-stat__stat-content__icons__yellow-card:hover .external-stat__tooltip,
.external-stat__stat-content__icons .external-stat__stat-content__icons__red-card:hover .external-stat__tooltip,
.external-stat__stat-content__icons .external-stat__stat-content__icons__blue-card:hover .external-stat__tooltip{
    visibility: visible;    
}

.external-stat__stat-content__data .locked_values {
    filter: blur(8px);
    cursor: unset;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 

    .external-stat__stat-header__image img {
        width: 35px;
        height: 35px;
        margin-right: 4px;
    }

    .external-stat__stat-header__tags .baloa-table-column {
        font-size: 9px;
        padding: 2px 6px;
        border-radius: 25px;
    }

    .external-stat__stat-header__tags {
        margin-top: 4px;
    }

    .external-stat__stat-content__icons {
        font-size: 14px;
        padding: 6px 0;
    }

    .external-stat__stat-content__data {
        padding: 0 0 16px 0;
    }

    .external-stat__stat-content__icons__yellow-card,
    .external-stat__stat-content__icons__red-card,
    .external-stat__stat-content__icons__blue-card {
        width: 10px;
        height: 14px;
    }

    .external-stat__stat-content__icons .baloa-normal-medium {
        font-size: 12px;
    }

    .external-stat__stat-content__data .baloa-normal-medium {
        font-size: 13px;
    }

    .external-stat__stat-header__edit-button .hubicon-edit {
        font-size: 18px;
    }

    .external-stat__stat-header__image .icon-trophy {
        font-size: 20px;
        padding: 8px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/external-stat/ExternalStatComponent.style.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,6CAA6C;IAC7C,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gCAAgC;IAChC,WAAW;IACX,gBAAgB;IAChB,uCAAuC;IACvC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;;;IAII,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gCAAgC;IAChC,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,yDAAyD;AAC7D;;AAEA;IACI,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iDAAiD;IACjD,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,2CAA2C;IAC3C,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;IACd,uBAAuB;;IAEvB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;;;;;;;IAQI,eAAe;AACnB;;AAEA;;;;;;;;IAQI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;;QAGI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;AACJ","sourcesContent":[".external-stat__stat {\n    margin-top: 14px;\n}\n\n.external-stat__stat-header {\n    display: flex;\n    align-items: center;\n}\n.external-stat__stat-header__image {\n    display: flex;\n    align-items: center;\n}\n\n.external-stat__stat-header__image img {\n    width: 53px;\n    height: 53px;\n    border-radius: 50%;\n    margin-right: 8px;\n}\n\n.external-stat__stat-header__image .icon-trophy {\n    color: var(--white-color);\n    background: var(--new-icon-color);\n    padding: 12px;\n    font-size: 30px;\n    border-radius: 50%;\n    margin-right: 8px;\n}\n\n.external-stat__stat-header__title,\n.external-stat__stat-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.external-stat__stat-header__title-name.baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n    align-self: flex-start;\n}\n\n.external-stat__stat-header__title-name .hubicon-verified {\n    font-size: 20px;\n    cursor: pointer;\n}\n\n.external-stat__stat-header__tags {\n    display: flex;\n    align-items: center;\n    margin-top: 8px;\n    gap: 4px;\n}\n\n.external-stat__stat-header__tags .baloa-table {\n    color: var(--primary-dark-color);\n}\n\n.external-stat__stat-header__tags .baloa-table-column {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n    padding: 3px 6px;\n    border-radius: 25px;\n    background-color: var(--new-background-color);\n    border: 1px solid var(--new-gray-color);\n}\n\n.external-stat__stat-content__icons {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 24px;\n    color: var(--primary-dark-color);\n    width: 100%;\n    margin-top: 16px;\n    background: var(--new-background-color);\n    padding: 6px 10px;\n    border-radius: 4px;\n}\n\n.external-stat__stat-content__icons .baloa-normal-medium {\n    color: var(--primary-dark-color);\n    margin: auto;\n    position: relative;\n}\n\n.external-stat__stat-content__icons .hubicon-titular,\n.external-stat__stat-content__icons .icon-ball,\n.external-stat__stat-content__icons .hubicon-assists,\n.external-stat__stat-content__icons .hubicon-goalkeeper {\n    margin: auto;\n    position: relative;\n}\n\n.external-stat__stat-content__data {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 24px;\n    color: var(--primary-dark-color);\n    width: 100%;\n    margin-top: 16px;\n    padding: 0 10px 24px 10px;\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.external-stat__stat-content__data .baloa-normal-medium {\n    color: var(--primary-dark-color);\n    margin: auto;\n}\n\n.external-stat__stat-header__edit-button {\n    align-self: flex-end;\n    margin-left: auto;\n}\n\n.external-stat__stat-header__edit-button .hubicon-edit{\n    color: var(--basic-gray-color);\n    font-size: 20px;\n    cursor: pointer;\n}\n\n.external-stat__stat-content__icons__yellow-card {\n    width: 18px;\n    height: 24px;\n    background-color: var(--new-yellow-warning-color);\n    position: relative;\n    margin: auto;\n}\n.external-stat__stat-content__icons__red-card {\n    width: 18px;\n    height: 24px;\n    background-color: var(--error-color);\n    position: relative;\n    margin: auto;\n}\n\n.external-stat__stat-content__icons__blue-card {\n    width: 18px;\n    height: 24px;\n    background-color: #0273FF;\n    position: relative;\n    margin: auto;\n}\n\n.external-stat__tooltip{\n    visibility: hidden;\n    width: 100px;\n    background-color: var(--primary-dark-color);\n    color: var(--white-color);\n    text-align: center;\n    border-radius: var(--space-and-half);\n    padding: 5px 0;\n    box-shadow: 0px 1px 2px;\n\n    /* Position the tooltip */\n    position: absolute;\n    z-index: 1000;\n    bottom: 40px;\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: bold;\n    font-size: var(--space-half-quarter);\n    line-height: var(--space);\n    right: -45px;\n}\n\n.external-stat__stat-content__icons .played_games:hover,\n.external-stat__stat-content__icons .hubicon-titular:hover,\n.external-stat__stat-content__icons .hubicon-goalkeeper:hover,\n.external-stat__stat-content__icons .hubicon-assists:hover,\n.external-stat__stat-content__icons .icon-ball:hover,\n.external-stat__stat-content__icons .external-stat__stat-content__icons__yellow-card:hover,\n.external-stat__stat-content__icons .external-stat__stat-content__icons__red-card:hover,\n.external-stat__stat-content__icons .external-stat__stat-content__icons__blue-card:hover {\n    cursor: pointer;\n}\n\n.external-stat__stat-content__icons .played_games:hover .external-stat__tooltip,\n.external-stat__stat-content__icons .hubicon-titular:hover .external-stat__tooltip,\n.external-stat__stat-content__icons .hubicon-goalkeeper:hover .external-stat__tooltip,\n.external-stat__stat-content__icons .hubicon-assists:hover .external-stat__tooltip,\n.external-stat__stat-content__icons .icon-ball:hover .external-stat__tooltip,\n.external-stat__stat-content__icons .external-stat__stat-content__icons__yellow-card:hover .external-stat__tooltip,\n.external-stat__stat-content__icons .external-stat__stat-content__icons__red-card:hover .external-stat__tooltip,\n.external-stat__stat-content__icons .external-stat__stat-content__icons__blue-card:hover .external-stat__tooltip{\n    visibility: visible;    \n}\n\n.external-stat__stat-content__data .locked_values {\n    filter: blur(8px);\n    cursor: unset;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n\n    .external-stat__stat-header__image img {\n        width: 35px;\n        height: 35px;\n        margin-right: 4px;\n    }\n\n    .external-stat__stat-header__tags .baloa-table-column {\n        font-size: 9px;\n        padding: 2px 6px;\n        border-radius: 25px;\n    }\n\n    .external-stat__stat-header__tags {\n        margin-top: 4px;\n    }\n\n    .external-stat__stat-content__icons {\n        font-size: 14px;\n        padding: 6px 0;\n    }\n\n    .external-stat__stat-content__data {\n        padding: 0 0 16px 0;\n    }\n\n    .external-stat__stat-content__icons__yellow-card,\n    .external-stat__stat-content__icons__red-card,\n    .external-stat__stat-content__icons__blue-card {\n        width: 10px;\n        height: 14px;\n    }\n\n    .external-stat__stat-content__icons .baloa-normal-medium {\n        font-size: 12px;\n    }\n\n    .external-stat__stat-content__data .baloa-normal-medium {\n        font-size: 13px;\n    }\n\n    .external-stat__stat-header__edit-button .hubicon-edit {\n        font-size: 18px;\n    }\n\n    .external-stat__stat-header__image .icon-trophy {\n        font-size: 20px;\n        padding: 8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
